import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Label, Row, Col, ButtonGroup, Button, Badge, Card, CardHeader, CardBody, CardFooter, CardTitle, CardText } from 'reactstrap';
import { Link } from "react-router-dom";
import { GroupsFilter, GroupDetails, PageTitle, StudentListItem, ClassroomListItem } from '../../../components';
import { Filters, Utils, isSuperAdmin } from '../../../services/';
import { matchSorter } from 'match-sorter';
import _ from 'lodash';

import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css'

import './GroupsList.css';
import {
    loadStudents, loadGroups,
    resetFileDownload, downloadRollCallPdf
} from '../../../redux/modules';
import Table from '../../../components/Table/Table';

import Icon from '@mdi/react';
import {
    mdiAccountGroupOutline,
    mdiFaceMan,
    mdiFaceWoman,
    mdiCastEducation,
    mdiCheckDecagramOutline,
    mdiAccountArrowRightOutline,
    mdiSquareEditOutline,
    mdiAccountSchoolOutline,
    mdiFileDownloadOutline,
} from '@mdi/js';

const GroupsList = props => {
    const [ filters, setFilters ] = useState({ day: -1, teacher: null, search: '' });
    const [ matchingStudents, setMatchingStudents ] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadStudents());
        dispatch(loadGroups());
    }, [])

    const { t }        = useTranslation();
    const { students } = useSelector(state => state.students);
    const {
        groups,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.groups);

    const default_lang = Utils.default_lang();

    const actions =
    <div>
        <Button tag={Link} to="/groups/new" color="success" size="sm">
            <i className="fa fa-plus"></i>&nbsp;
            {t('groups.add_a_group')}
        </Button>
    </div>;

    const filteredGroups = React.useMemo(() => {
        setMatchingStudents([]);
        return (groups || [])
            .filter(g => {
                if (filters.day < 0)
                    return true;
                return _.some(g.classrooms, ['week_day', filters.day]);
            })
            .filter(g => {
                if (!filters.teacher)
                    return true;
                return _.some(g.classrooms, ['teacher.id', filters.teacher]);
            })
            .filter(g => {
                if (!filters.search)
                    return true;

                const matching = matchSorter(g.students, filters.search, {keys: ['firstname', 'lastname']});
                setMatchingStudents(matching);
                return !!matching.length;
            })
            .sort((a, b) => a.min_age == b.min_age ? a.name.localeCompare(b.name) : a.min_age - b.min_age)
    }, [groups, filters]);

    return (
        <div className="GroupsList">
            <PageTitle icon={mdiAccountGroupOutline} title={t('groups.group_plural')} actions={ actions } />
            <Row className="row-flex justify-content-md-start">
                <Col md={6}>
                    <Card color="dark" className="text-light h-100">
                        <CardBody>
                            <Row className=" justify-content-md-center">
                                <Col md={12}>
                                    <GroupsFilter groups={groups} onChange={ filters => setFilters(filters) }/>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={2}>
                    <Card color="light" className="text-dark h-100">
                        <CardBody className="d-flex align-items-center">
                            <CardTitle tag="h1" className="align-items-center">
                                <strong>
                                    { groups?.length }&nbsp;
                                </strong>
                                <small>
                                    { t('groups.total_groups') }
                                </small>
                            </CardTitle>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={2}>
                    <Card color="light" className="text-dark h-100">
                        <CardBody className="d-flex align-items-center">
                            <CardTitle tag="h1" className="align-items-center">
                                <strong>
                                    { students?.length }&nbsp;
                                </strong>
                                <small>
                                    { t('groups.total_students') }
                                </small>
                            </CardTitle>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={2}>
                    <Card color="light" className="text-dark h-100">
                        <CardBody className="d-flex align-items-center">
                            <CardTitle tag="h1" className="align-items-center">
                                <strong>
                                    { groups?.reduce((memo, group) => memo + group.students.length, 0) }&nbsp;
                                </strong>
                                <small>
                                    { t('groups.students_in_group') }
                                </small>
                            </CardTitle>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                { filteredGroups.map(group => (
                <Col key={ group.id } sm={12} className="mb-3">
                    <GroupDetails group={group} filters={filters} />
                </Col>
            ))}
            </Row>
        </div>
    );
}

export default GroupsList;
